import Footer from "../Components/footer";
import Header from "../Components/Header";
import Form from "../Components/Form";
import React, { useState} from 'react';
import { useNavigate } from "react-router-dom";
import Faqaccordian from '../Components/Faqaccordian';
import CompanyLogoSlider from "../Components/CompanyLogoSlider";
import CustomSlider2 from "../Components/CustomSlider2";
import NewForm from "../Components/NewForm";
import CardSwiperSlider from "../Components/CardSwiperSlider";
import GoogleReviewsWidget2 from "../Components/GoogleReviewsWidget2";
import MoSlider from "../Components/MoSlider";
import { Helmet } from "react-helmet-async";
import CardSwiperSliderMobile from "../Components/CardSwiperSliderMobile";

const WebsiteDevlopmentPageIndia = () =>  {

  
const sec5dot1 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot1.png";
const sec5dot2 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot2.png";
const sec5dot3 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot3.png";
const sec5dot4 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot4.png";
const stagesbg = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/stagesbg.png";


const imagesCard = [
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card1.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card2.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card3.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card4.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card5.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card6.svg",

  
];
const MobileimagesCard = [
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard1.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard2.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard3.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard4.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard5.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard6.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard8.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard9.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard10.svg",

 
];

const slidesData = [

{
  id: 1,
  title: "Salon at Home – Book Your Appointment for a Luxurious Experience!",
  description:"Enjoy a premium salon experience in the comfort of your home. Our expert beauticians bring top-quality services, from hairstyling and facials to manicures, pedicures, and more—tailored to your needs.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img1.png", 
  bgcolor: 'rgba(255, 60, 115, 1)',
  btntext:'Visit Now',
  url:'https://www.lookplex.com/'
},
{
  id: 2,
  title: "Global Medical Community App",
  description:"A collaborative platform where doctors, medical professionals, and patients connect, share case studies, and manage health records in one place.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img2.png", 
  bgcolor: 'rgba(0, 52, 164, 1)',
  btntext:'Download Now',
  url:'https://www.smartcare.health/'
},
{
  id: 3,
  title: "Appointment Booking & Queue Management App",
  description:"Effortlessly find and book services—doctors, salons, restaurants, spas—near you, all while skipping the wait with real-time queue updates.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img3.png", 
  bgcolor: 'rgba(0, 161, 163, 1)',
  btntext:'Download Now'
},
{
  id: 4,
  title: "Journey of Miles: Tour & Travel App",
  description:"Explore and book curated travel packages across India. From hidden gems to popular destinations, plan your next adventure with ease.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img4.png", 
  bgcolor: 'rgba(46, 155, 95, 1)',
  btntext:'Visit Now'
},
{
  id: 5,
  title: "Book Doctor Appointments Effortlessly – Anytime, Anywhere!",
  description:"Say goodbye to long waiting times and complicated booking processes! Our doctor appointment booking software makes it quick and easy to schedule consultations with trusted healthcare professionals.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img5.png", 
  bgcolor: 'rgba(0, 163, 255, 1)',
  btntext:'Download Now'
},
{
  id: 6,
  title: "Clinic Management App",
  description:"Streamline your medical practice with comprehensive scheduling, patient record management, and secure communication—all in one user-friendly app.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img6.png", 
  bgcolor: 'rgba(14, 39, 187, 1)',
  btntext:'Download Now'
},
];

const ratings = [
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img2.svg",
    rating: 4.9,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/clutch_img1.svg",
    rating: 4.8,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img3.svg",
    rating: 4.6,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/mob-add-img.png",
    rating: 4.4,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/google-mo1.png",
    rating: 4.8,
  },
];




    // ================ Mailer code start from here =====================
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
        phone: "",
      });
      const [responseMessage, setResponseMessage] = useState(""); 
      const [loading, setLoading] = useState(false); // State for loader
      const navigate = useNavigate(); // Initialize useNavigate
      const [errors, setErrors] = useState({}); 
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
    
     
      const validateForm = () => {
        let formErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[0-9]{10}$/; // Assumes phone number should be 10 digits
    
        if (!formData.email || !emailRegex.test(formData.email)) {
          formErrors.email = "Please enter a valid email address.";
        }
    
        if (!formData.phone || !phoneRegex.test(formData.phone)) {
          formErrors.phone = "Please enter a valid 10-digit phone number.";
        }
    
        if (!formData.message || formData.message.trim().length < 10) {
            formErrors.message = "Please enter a message with at least 10 characters.";
          }
    
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!validateForm()) {
          return;
        }
        setLoading(true); // Show loader
    
        try {
          const response = await fetch(
            "https://mailer.datametricks.com/send-email.php",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            }
          );
    
          const result = await response.json(); // Parse JSON from the response
    
          setResponseMessage(result.message);
    
          if (result.status === "success") {
            setTimeout(() => {
              setLoading(false); // Hide loader
              navigate("/Successemailpage"); // Redirect to Thank You page
            }, 1000); // Delay redirect by 2 seconds
          } else {
            setLoading(false); // Hide loader if not successful
          }
        } catch (error) {
          setResponseMessage("Error submitting form.");
          setLoading(false); // Hide loader on error
        }
      };
    
      // ================ Mailer code end here =====================


 const ratingstar = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/ratingstar.svg";



 
var faqDataweb=[
  {que1:"1. What is web development and why is it important?",ans1:"Web development involves creating and maintaining websites. It includes web design, web publishing, web programming, and database management. A well-developed website enhances a business's online presence, boosts credibility, attracts customers, and drives sales." },
  {que1:"2. How much does it cost to develop a website? ", ans1:"The cost of developing a website can vary greatly depending on factors such as complexity, features, design, and the development company."},
  {que1:"3. How long does it take to build a website? ",ans1:"The time required to build a website depends on its complexity and the specific requirements of the project. A simple website might take a few weeks, while a more complex site with custom features can take several months."},
  {que1:"4. What are the key features of a good website? ",ans1:"A good website should be user-friendly, responsive (works on all devices), fast-loading, secure, SEO-optimized, and visually appealing. It should also have clear navigation, engaging content, and effective call-to-actions. "},
  {que1:"5. Do I need a mobile-friendly website? ",ans1:"Yes, having a mobile-friendly (responsive) website is essential as more people access the internet through mobile devices. A mobile-friendly site improves user experience, boosts SEO rankings, and increases the chances of retaining visitors. "},
  {que1:"6. What is SEO and why is it important for my website? ",ans1:"SEO (Search Engine Optimization) involves optimizing your website to rank higher in search engine results. It is important because higher rankings lead to increased visibility, more traffic, and potentially more customers. "},
  {que1:"7. Can I update my website content by myself? ",ans1:"Yes, if your website is built with a Content Management System (CMS) like WordPress, you can easily update your content without needing technical knowledge. A CMS allows you to add, edit, and delete content as needed. " },
  {que1:"8. What is the difference between web design and web development? ",ans1:"Web design focuses on the visual aspects of a website, including layout, color schemes, and graphics. Web development, on the other hand, involves coding and programming to create the website’s functionality and features. " },
  {que1:"9. Why should I choose DataMetricks for my web development needs? ",ans1:"Datametricks Consulting offers expert web development services tailored to your business needs. We prioritize user experience, use the latest technologies, and provide ongoing support to ensure your website is always optimized and effective. "},
  {que1:"10. What kind of support do you provide after the website is launched? ",ans1:"We offer comprehensive support and maintenance services, including regular updates, security checks, performance optimization, and troubleshooting to ensure your website remains secure and performs at its best. "},    
];

return(



    <div>

    <Helmet>
        <title>Expert Website Development Services | Custom Web  Apps | DataMetricks</title>
        <meta name="description" content="Transform your vision into powerful website with our expert team. Specializing in iOS, Android & cross-platform solutions. Contact us today" />
      </Helmet>


        <section>
                <Header/>
               
        </section>


        <section >
            <div   style={{backgroundColor:'#EDEDED'}}>
                <div className="container" style={{paddingBottom:'35px'}}>
{/* 
              <div className="justify-content-center d-flex fixed-top mt-10 px-1">
              <div className="MoNavClass  mb-lg-5 ">          
            <div className="d-flex justify-content-between" >
            <a href="#">
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/DM-White-Logo.png" alt="" className="img-fluid Mo-logo-img"  style={{width:'226px',height:'42px'}}/>
                </a>
                <a href="#formsection">
                <button class="btn hoverclass" type="submit" style={{backgroundColor:'rgba(255, 255, 255, 1)',fontSize:'18px',fontWeight:'700'}}>Let’s Talk</button>
                </a>
          </div>
                </div>
              </div> */}

                    <div className="row justify-content-center paddingt-35" style={{paddingTop:'10%'}}>
                        <div className="col-lg-7 col-12">
                        <p className="fw-800 fs-55 plus mb-0  font-28 lineheight" style={{color:'rgba(0, 83, 154, 1)',lineHeight:'72px'}}>Website Development Company in India </p>

                            <p className="fw-500 fs-17 plus pt-lg-4 pt-20 hideinmo" style={{color:'rgba(0, 0, 0, 0.7)'}}>Affordable, Professional, and Tailored Web Development Services, Save costs without compromising quality. Web, software, and app development. <span className="fs-18 fw-700" style={{color:'rgba(0, 83, 154, 1)'}}>Contact us now! </span></p>

               <div className="hideinmo">
                <p className="fs-20 fw-700 plus pt-3" style={{color:'rgba(0, 83, 154, 1)'}}>Our Impact and Recognition</p>


<div className="row gap-3 mt-lg-5">
  {ratings.map((item, index) => (
    <div key={index} className="col-md-2 col-6 d-flex justify-content-center">
      <div
        className="d-flex flex-column align-items-center "
        style={{
          width: "150px",
          height: "180px",
        
        }}
      >
        <img
          src={item.img}
          alt="rating-img"
          className="img-fluid"
          style={{ width: "100%", height: "100px", objectFit: "contain" }}
        />

        <div className="mt-2 d-flex align-items-center justify-content-center">
          <span className="fs-5 fw-bold text-dark">{item.rating}</span>
          <img
            src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
            alt="star-icon"
            style={{ width: "60px", marginLeft: "5px" }}
          />
        </div>
      </div>
    </div>
  ))}
</div>

              


               </div>
                        </div>


                        <div className="col-lg-5 col-12  mt-10">

                          <div style={{position:'relative'}}>
                            <div className="hideinmo">
                          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/laptop-img.png" alt="" className="img-fluid" />
                          </div>

                          <div className="hideinmo" style={{position:'absolute',left:'0',right:'0',bottom:'0',top:'50%'}}>
                          <form onSubmit={handleSubmit}>
                            <div className="px-4 pt-3 pb-4" style={{boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)', backgroundColor:'rgba(244, 250, 255, 1)',borderRadius:'24px'}}>
                               <p className="fs-28 fw-700 pop mb-0 font-20" style={{color:'rgba(27, 27, 27, 1)'}}>Ready to Start Your Project?</p>
                               <p className="fw-700 fs-25 pop pt-1 font-20" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>

                               <div >
                                <input className="w-100"
                                
                                type="text" placeholder="Name*" 
                                id="fname"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                               </div>

                    <div className="mt-4 row">
                      <div className="col-md-6">
                               <div >
                                <input className="w-100" type="tel"
                                  name="phone"  
                                  value={formData.phone}
                                  onChange={handleChange}  
                                  required                
                                  placeholder="Mobile Number*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                                  {errors.phone && (
                        <p
                          className="error-text"
                          style={{
                            fontSize: "12px",
                            color: "red",
                            marginTop: "10px",
                          }}
                        >
                          {errors.phone}
                        </p>
                      )}
                               </div>
                               </div>

                               <div className="col-md-6">

                               <div >
                                <input className="w-100" type="email"
                                 id="email" name="email"  value={formData.email}
                                 onChange={handleChange}
                                 required
                                placeholder="Email*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                           {errors.email && <p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>{errors.email}</p>}

                               </div>
                               </div>

                               </div>

                               <div className="mt-4" >
                                <input className="w-100" type="text" placeholder="Message..."
                                 name="message"  value={formData.message}
                                 onChange={handleChange}
                                 form="usrform"
                                 required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                         {errors.message && (<p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }} > {errors.message} </p>)}

                               </div>
                          
                               <div className="mt-5" >
                               <button type="submit" className="btn btn-sm w-100" disabled={loading} style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(27, 27, 27, 1)',color:'white',borderRadius:'50px',border:'none',outline:'none',padding:'12px 60px 12px 60px'}}>
                        {loading ? (
                                    <>
            
                         <div className="spinner"></div>
                
                              </>
                          ) : (
                                "Submit"
                              )}

                         </button>
                               </div>
                            </div>
                          </form>
                          </div>

                          </div>

                           
                          <div className="hideindesktop">
                          <form onSubmit={handleSubmit}>
                            <div className="px-4 pt-3 py-4" style={{boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)', backgroundColor:'rgba(244, 250, 255, 1)',borderRadius:'24px'}}>
                               <p className="fs-28 fw-700 pop mb-0 font-22" style={{color:'rgba(27, 27, 27, 1)'}}>Ready to Start Your Project?</p>
                               <p className="fw-700 fs-25 pop pt-1 font-20" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>

                               <div >
                                <input className="w-100"
                                
                                type="text" placeholder="Name*" 
                                id="fname"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                               </div>

                    <div className="mt-4 row">
                      <div className="col-md-6">
                               <div >
                                <input className="w-100" type="tel"
                                  name="phone"  
                                  value={formData.phone}
                                  onChange={handleChange}  
                                  required                
                                  placeholder="Mobile number*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                                  {errors.phone && (
                        <p
                          className="error-text"
                          style={{
                            fontSize: "12px",
                            color: "red",
                            marginTop: "10px",
                          }}
                        >
                          {errors.phone}
                        </p>
                      )}
                               </div>
                               </div>

                               <div className="col-md-6 pt-4">

                               <div >
                                <input className="w-100" type="email"
                                 id="email" name="email"  value={formData.email}
                                 onChange={handleChange}
                                 required
                                placeholder="Email*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                           {errors.email && <p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>{errors.email}</p>}

                               </div>
                               </div>

                               </div>

                               <div className="mt-4" >
                                <input className="w-100" type="text" placeholder="Message..."
                                 name="message"  value={formData.message}
                                 onChange={handleChange}
                                 form="usrform"
                                 required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                         {errors.message && (<p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }} > {errors.message} </p>)}

                               </div>
                          
                               <div className="mt-4" >
                               <button type="submit " className="btn btn-sm w-100" disabled={loading} style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(27, 27, 27, 1)',color:'white',borderRadius:'50px',border:'none',outline:'none',paddingBottom:'6px'}}>
                        {loading ? (
                                    <>
            
                         <div className="spinner"></div>
                
                              </>
                          ) : (
                                "Submit"
                              )}

                         </button>
                               </div>
                            </div>
                          </form>
                          </div>

                         
                          
                        </div>
                       
                       
                    </div>

                    <div className="hideindesktop">
  <p
    className="fs-20 fw-700 plus pt-3"
    style={{ color: "rgba(0, 83, 154, 1)" }}
  >
    Our Impact and Recognition
  </p>
  <div
    className="d-flex justify-content-between align-items-center mt-3"
    style={{ gap: "10px" }} 
  >
    {/* Box 1 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo1.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }} 
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.9{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 2 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo2.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.8{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 3 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo3.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.6{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 4 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo4.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.8{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>
  </div>
</div>

                </div>
              
            </div>
        </section>



        <section>
          <div className="mt-4">
            <h2 className="fw-800 fs-35 plus text-center font-25">A Glimpse of Our Recent Work</h2>

         

            {/* <div className="hideinmo">
 <CardSwiperSlider  imagesData={imagesCard}/>
 </div>

 <div className="hideindesktop">
 <CardSwiperSliderMobile   mobileimageData={MobileimagesCard}/>
 </div> */}
          </div>
        </section>


<section>
  <div className="container mt-lg-5 mt-30">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="d-flex gap-2">
          <div>
            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/shopify1.png" alt="" className="img-fluid " />
          </div>
          <div>
            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/wix.png" alt="" className="img-fluid " />
          </div>
        </div>
        <div className="mt-2">
            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/woo.png" alt="" className="img-fluid " />
          </div>
      </div>
      <div className="col-lg-6 ">
        <div className="mt-20 textcenter d-sm-none d-none d-md-block d-lg-block">
          <p className="fw-700 fs-40 plus font-20">Empower Your Online Presence with a Custom CMS Solution</p>
          <p className="fs-17 plus" style={{color:'rgba(34, 34, 34, 0.6)'}}>In today’s competitive digital marketplace, a powerful e-commerce website is more than just a storefront—it’s your gateway to reaching a global audience, building trust, and driving revenue. At Datametricks Consulting Pvt. Ltd., we design and develop e-commerce websites that deliver exceptional shopping experiences, tailored to your business goals.</p>
        </div>
</div>
    </div>
  </div>
</section>

        <section>
            <div className="container mt-lg-5 mt-20">
                <div className="row justify-content-center">

                    <div className="col-lg-8">
                <p className="fw-800 fs-40 plus text-center font-25">Grow Your Business with Our Expert Web Development Services</p>
                <p className="fs-18 fw-400 plus text-center" style={{color:'rgba(0, 0, 0, 0.6)'}}>Partner with India’s top website development company to create websites that stand out. Here’s why  you should choose us:</p>
                </div>

                </div>

                <div className="row justify-content-center  mt-lg-3 g-0 g-2 pt-10">
                <div className="col-lg-6 col-12 col-md-3">

                      <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/ecomm-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>E-Commerce Development</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>We build custom software solutions tailored for the  e-commerce sector. Our team focuses on  creating affordable, secure, and fully customized e-commerce websites that provide a seamless  shopping experience for your customers.</p>
                       
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/website-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Website Design & Development</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Crafting bespoke websites that merge creativity with functionality to elevate your online presence</p>
                       
                    </div>
                       
                        </div>
              
                 </div>

                 <div className="row justify-content-center g-0 g-2 " style={{paddingTop:'8px'}}>
                <div className="col-lg-6 col-12 col-md-3">

                      <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/static-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Static Website Development</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>We build custom software solutions tailored for the  e-commerce sector. Our team focuses on  creating affordable, secure, and fully customized e-commerce websites that provide a seamless  shopping experience for your customers.</p>
                       
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/responsive-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Responsive Design</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Creating seamless user experience across all devices, ensuring your website looks and functions  flawlessly on every screen size</p>
                       
                    </div>
                       
                        </div>
              
                 </div>

                 <div className="row justify-content-center g-0 g-2 " style={{paddingTop:'8px'}}>
                <div className="col-lg-6 col-12 col-md-3">

                      <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/dynamic-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Dynamic Website Development</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>We build custom software solutions tailored for the  e-commerce sector. Our team focuses on  creating affordable, secure, and fully customized e-commerce websites that provide a seamless  shopping experience for your customers.</p>
                       
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center ">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/custom-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Custom Website Development</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Crafting bespoke websites that merge creativity with functionality to elevate your online presence</p>
                       
                    </div>
                       
                        </div>
              
                 </div>

                 <div className="row justify-content-center g-0 g-2 " style={{paddingTop:'8px'}}>
                <div className="col-lg-6 col-12 col-md-3">

                      <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/wordpress-icon2.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>WordPress  Website Development</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>We build custom software solutions tailored for the  e-commerce sector. Our team focuses on  creating affordable, secure, and fully customized e-commerce websites that provide a seamless  shopping experience for your customers.</p>
                       
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center ">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/backend-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Backend Development</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Creating seamless user experience across all devices, ensuring your website looks and functions  flawlessly on every screen size.</p>
                       
                    </div>
                       
                        </div>
              
                 </div>

                 <div className="row justify-content-center g-0 g-2 " style={{paddingTop:'8px'}}>
                <div className="col-lg-6 col-12 col-md-3">

                      <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/content-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Content Management Systems</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Empowering you with intuitive platforms to manage and updates your website content effortlessly.</p>
                       
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center ">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/maintanance-icon.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Website Maintenance & Support</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Ensuring your website remains secure, updated, and optimized for peak performance.</p>
                       
                    </div>
                       
                        </div>
              
                 </div>

            <div className="text-center mt-4">
             <a href="#formsection" >   <button className="btn btn-sm px-5 py-3 mt-3" style={{border:'1px solid rgba(189, 189, 189, 1)',borderRadius:'7px'}}>
                                <div className="d-flex align-items-center justify-content-center w-100">
                                    <p className="fw-500 fs-17 plus m-0" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/right-web-arrow.svg" alt="" className="ms-2" />
                                </div>
                            </button> </a> 
                            </div>
               
            </div>

        </section>
 
       <section>
        <div className="container mt-5">
        <div className="row justify-content-center  mt-lg-3 g-0 g-2 pt-10 textcenter">
                <div className="col-lg-6 col-12 col-md-3 ">

                      <div className="px-4 pt-3 " style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                           
                                <div>
                                    <p className="fw-700 fs-18 plus font-15 mb-0 " >Custom Web Applications Development</p>
                                </div>
                           <p className="fw-500 fs-14 plus pt-2 hideinmo " style={{color:'rgba(0, 0, 0, 0.7)'}}>Our website development company specializes in prototyping and MVP creation for your custom web application. Our primary focus is on designing user-friendly UI/UX that enhances engagement and provides an enjoyable experience for users. </p>
                           <div className="d-flex justify-content-center">
                       <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/custom-card-img.svg" alt="" className="img-fluid  mt-20" />
                       </div>
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 pt-3 h-100 " style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                           
                                <div>
                                    <p className="fw-700 fs-18 plus font-15 mb-0" >Progressive Web App Development</p>
                                </div>
                           <p className="fw-500 fs-14 plus pt-2 hideinmo" style={{color:'rgba(0, 0, 0, 0.7)'}}>Our team of expert website developers brings extensive experience in creating innovative, progressive web applications that are fast, reliable, and secure. We leverage the latest technologies to design and develop cutting-edge web applications.</p>
                           <div className="d-flex justify-content-center">
                       <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/webapp-card-img.svg" alt="" className="img-fluid  mt-20" />
                       </div>
                    </div>
                       
                        </div>

              
                 </div>

                 <div className="row justify-content-center  mt-lg-1 g-0 g-2 pt-10 textcenter">
                <div className="col-lg-6 col-12 col-md-3 ">

                      <div className="px-4 pt-3 " style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                           
                                <div>
                                    <p className="fw-700 fs-18 plus font-15 mb-0 " >E-Commerce Solutions</p>
                                </div>
                           <p className="fw-500 fs-14 plus pt-2 hideinmo " style={{color:'rgba(0, 0, 0, 0.7)'}}>Our team specializes in creating eCommerce websites that are both cost-effective and reliable, ensuring a seamless shopping experience for your customers. We focus on building secure, scalable, and user-friendly online stores tailored to your business needs.</p>
                           <div className="d-flex justify-content-center">
                       <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/ecomm-card-img.svg" alt="" className="img-fluid  mt-20" />
                       </div>
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 pt-3 h-100 " style={{borderRadius:'17px',boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                           
                                <div>
                                    <p className="fw-700 fs-18 plus font-15 mb-0" >Full-Stack Development</p>
                                </div>
                           <p className="fw-500 fs-14 plus pt-2 hideinmo" style={{color:'rgba(0, 0, 0, 0.7)'}}>DataMetricks is a top web development company in India, providing custom solutions with front-end and back-end technologies like MEAN, MERN, PHP, Node.js, and Angular. We build scalable, high-performance websites tailored to your business needs.</p>
                           <div className="d-flex justify-content-center">
                       <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/fullstack-card-img.svg" alt="" className="img-fluid  mt-20" />
                       </div>
                    </div>
                       
                        </div>

              
                 </div>
        </div>
       </section>


       <section className=" Mobg1 " style={{overflow:'hidden',marginTop:'60px'}}>
            <div className="container pt-4 pb-5">
                <p className="fw-800 plus fs-35 text-center font-25" style={{color:'white'}}>Why Choose Our Website Development Company in India?</p>
        <div className="hideinmo">
                <div className="row justify-content-center mt-lg-4 g-0 g-2 ">
                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon9.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>Affordable Pricing</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>Hire dedicated website developers starting at just $20/hour.</p>

                        </div>

                    </div>

                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-lg-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon10.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>Global Clientele</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>Trusted by clients across different regions.</p>

                        </div>

                    </div>

                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-lg-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon11.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>Proven Track Record</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>Over 100+ projects completed for startups and enterprises.</p>

                        </div>

                    </div>
                </div>

                <div className="row justify-content-center pt-2 g-0 g-2">
                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-lg-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon9.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>Cutting-Edge Technology</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>We stay updated with the latest trends to deliver innovative solutions.</p>

                        </div>

                    </div>

                    <div className="col-lg-3 col-12 col-md-3">
                        <div className="text-center p-4 h-100" style={{borderRadius:'10px'}}>
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Us-icon10.svg" alt="" />
                            <p className="fw-700 fs-20 plus pt-2" style={{color:'white'}}>24 / 7 Support</p>
                            <p className="fw-500 fs-15 plus " style={{color:'rgba(255, 255, 255, 0.73)'}}>Our team is always available to assist you via Teams, Skype, email, or Zoom.</p>

                        </div>

                    </div>

                
                </div>
                </div>

{/* Mobile view  */}
<div className="mt-4">
                <MoSlider/>
                </div>

            </div>
        </section>


<section>
    <div className=" px-3 pt-4 pb-5 " style={{backgroundColor:'rgba(0, 83, 154, 1)'}}>
        <div className="container">
            <div className="row justify-content-center align-items-center">
                <div className="col-lg-7 col-12">
                    <p className="fs-50 plus fw-800 font-25" style={{color:'rgba(255, 255, 255, 1)'}}>Looking to Accelerate Your Mobile App Development?</p>
                </div>
                <div className="col-lg-4 col-12">
                <div className="textcenter">
                <a href="#formsection">
                    <button type="button" className="btn btn-sm font-14  pt-2  px-4 mt-3" style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(255, 255, 255, 1)',borderRadius:'45px',border:'none',outline:'none',paddingBottom:'10px'}}>
                    Discover how we can help
                    </button>
                </a>
            </div>
                    </div>
            </div>
        </div>
    </div>
</section>







        <section className="pb-5 pt-4 " style={{backgroundColor:'rgba(232, 252, 255, 1)'}}>

  <div>
         <p className="fw-800 fs-35 plus font-22 text-center plr-10" style={{color:'rgba(0, 0, 0, 1)'}}>Trusted Website Development Company in India for <br/> Diverse Industries</p>  
         <p className="fw-500 fs-16 plus text-center plr-20" style={{color:'rgba(0, 0, 0, 0.6)'}}>At DataMetricks, we are committed to providing professional website development services across a wide range of industries, including retail, <br/> real estate, finance, education, healthcare, and more. As a leading web development company in India, we collaborate with offshore partners <br/> to deliver exceptional web design, application development, and eCommerce solutions.</p>                   
   
  </div>



  <div className="hideinmo">
 <CardSwiperSlider  imagesData={imagesCard}/>
 </div>

 <div className="hideindesktop">
 <CardSwiperSliderMobile   mobileimageData={MobileimagesCard}/>
 </div>

 <div className="text-center mt-4">
             <a href="#formsection " >   <button className="btn btn-sm px-5 py-3 mt-3" style={{border:'1px solid rgba(189, 189, 189, 1)',borderRadius:'7px'}}>
                                <div className="d-flex align-items-center justify-content-center w-100">
                                    <p className="fw-500 fs-17 plus m-0" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/right-web-arrow.svg" alt="" className="ms-2" />
                                </div>
                            </button> </a> 
                            </div>

</section>


<section>
                <div className="container mt-5">
                    <p className="fs-20 fw-600 plus text-center mb-0" style={{color:'rgba(0, 83, 154, 1)'}}>Our Pratners</p>
                    <p className="fw-700 fs-35 plus text-center" >We work with the best partners </p>
                    <div className="row justify-content-center ">
                        <div className="col-lg-10">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/our-partner.svg" alt="" className="img-fluid mt-4" />
                        </div>

                    </div>
                </div>

            </section>
    





    <section>
  <div className="container  mt-10" style={{marginTop:'60px'}}>
    <div className="row justify-content-center align-items-center">
      <div className="col-lg-5 textcenter">
        <p className="fs-40 fw-800 plus font-25" style={{color:'rgba(0, 83, 154, 1)'}}>What Makes DataMetricks Stand Out?</p>
        <a href="#formsection">
                    <button type="button" className="btn btn-sm font-14    px-4" style={{fontSize:'18px',fontWeight:'700',borderRadius:'45px',border:'1.5px solid rgba(0, 83, 154, 1)',outline:'none',color:'rgba(0, 83, 154, 1)'}}>
                    Get a Free Quote
                    </button>
         </a>
      </div>


      <div className="col-lg-6 mt-30">
        <div className="row g-2 ">
          <div className="col-md-6">
            <div className="pt-3 pb-1 px-4 h-100" style={{backgroundColor:'rgba(255, 235, 226, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Successful Projects</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>Proven track record of delivering high-quality solutions across various industries.</p>
                <p className="fw-800 fs-40 plus pt-1 font-25" style={{color:'rgba(180, 84, 40, 1)'}}>100+</p>
            </div>

          </div>
          <div className="col-md-6">
            <div className="pt-3 pb-1 px-4 h-100" style={{backgroundColor:'rgba(232, 252, 255, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Skilled Developers</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>A dedicated team of professionals with expertise in cutting-edge technologies.</p>
                <p className="fw-800 fs-40 plus pt-1 font-25" style={{color:'rgba(62, 156, 170, 1)'}}>30+</p>
            </div>

          </div>

        </div>

        <div className="row pt-2">
          <div className="col-md-12">
            <div className="pt-3 pb-1 px-4 " style={{backgroundColor:'rgba(240, 250, 240, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Client Satisfaction</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>Commitment to excellence, ensuring top-tier service and customer success.</p>
                <p className="fw-700 fs-40 plus pt-1 font-25" style={{color:'rgba(93, 169, 93, 1)'}}>4.8 Google Ratings</p>
            </div>
          </div>
          </div>

</div>

    </div>

  </div>
</section>


<section className="mt-5">

<section className='d-none d-sm-none d-lg-block d-md-block'>

<div >
        <p className="fs-35 fw-700 plus text-center mb-0 font-20">Key Steps in Our Website Development Process</p>
        <p className="fw-500 fs-16 plus text-center pt-2" style={{color:'rgba(0, 0, 0, 0.6)'}}> Tailored to your needs and budget, we use top practices to build mobile app solutions quickly and efficiently.<br/> Enjoy a smooth mobile app development process with clear communication with our professional team.</p>
        {/* <p className="fs-35 fw-700 plus text-center font-20"> Process from Concept to Launch</p> */}

 </div>
 <div className="container mt-lg-5 ">
<div className="row ms-lg-5">
  <div className="col-lg-4 ">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot1} alt=""  />
      </div>
      <div>
        <p className="sec5title mb-0 mt-1">
          1. Discovery and Planning
        </p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
         Understanding your goals, target audience, and requirements to  lay a solid foundation for the project.
        </p>
      </div>
    </div>
  </div>
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot2} alt="" />
      </div>
      <div>
        <p className="sec5title mb-0 mt-1">2. Design</p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Bringing your vision to life with captivating visuals and
          intuitive user interfaces.
        </p>
      </div>
    </div>
  </div>
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot1} alt="" />
      </div>
    
      <div>
        <p className="sec5title mb-0 mt-1">3. Development</p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Transforming designs into functional <br /> websites with
          clean code and seamless functionality.
        </p>
      </div>
    </div>
  </div>
</div>
</div>
<div className="container">

<div className="col-lg-12 ms-lg-5">
<img className="img-fluid" src={stagesbg} alt="" />
</div>
</div>
<div className="container pt-4 ">
<div className="row ms-lg-5">
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot3} alt="" />
      </div>
      <div>
        <p className="sec5title mb-0 mt-1">4. Testing </p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Thoroughly checking every aspect of the website to ensure
          it meets quality standards and performs flawlessly.
        </p>
      </div>
    </div>
  </div>
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot4} alt="" />
      </div>
     
      <div>
        <p className="sec5title mb-0 mt-1">5. Launch</p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Deploying the website to the live <br /> environment and
          making it accessible to your audience.
        </p>
      </div>
    </div>
  </div>
  <div className="col-lg-4">
    <div className="d-flex  gap-2">
      <div>
        <img src={sec5dot3} alt="" />
      </div>
      <div>
        <p className="sec5title mb-0 mt-1">6. Beyond</p>
        <p
          style={{ paddingLeft: "17px !important" }}
          className="para1"
        >
          Providing ongoing support, maintenance, and updates to
          ensure your website remains optimized and up to date.
        </p>
      </div>
    </div>
  </div>
</div>



</div>
    
</section>

{/* mobile view */}
<section className='d-block d-sm-block d-lg-none d-md-none'>
  <div className='container mt-4 '>
  <p className="fs-35 fw-700 plus text-center mb-0 font-20">Key Steps in Our Website Development Process</p>
  

    <div className='row justify-content-center'>
      {/* <div className='col-3'>
         <img style={{height:'532px'}} src="/assets/" alt="" className="img-fluid" />
      </div> */}
      <div className='col-10 mt-4'>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot1} alt=""  />
          </div>
          <div>
            <p className="sec5title fs-15 mb-0 mt-1">
              1. Discovery and Planning
            </p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12 "
            >
            Understanding your goals, target audience, and requirements to  lay a solid foundation for the project.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot2} alt="" />
          </div>
        
          <div>
            <p className="sec5title mb-0 mt-1 fs-15">2. Design</p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Bringing your vision to life with captivating visuals and
              intuitive user interfaces.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot1} alt="" />
          </div>
        

          <div>
            <p className="sec5title mb-0 mt-1 fs-15">3. Development </p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Transforming designs into functional <br /> websites with
              clean code and seamless functionality.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot3} alt="" />
          </div>
       
          <div>
            <p className="sec5title mb-0 mt-1 fs-15">4. Testing </p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Thoroughly checking every aspect of the website to ensure
              it meets quality standards and performs flawlessly.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot4} alt="" />
          </div>
       
          <div>
            <p className="sec5title mb-0 mt-1 fs-15">5. Launch</p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Deploying the website to the live <br /> environment and
              making it accessible to your audience.
            </p>
          </div>
        </div>
        <div className="d-flex  gap-2">
          <div>
            <img src={sec5dot3} alt="" />
          </div>
          <div>
            <p className="sec5title mb-0 mt-1 fs-15">6. Beyond</p>
            <p
              style={{ paddingLeft: "17px !important" }}
              className="para1 fs-12"
            >
              Providing ongoing support, maintenance, and updates to
              ensure your website remains optimized and up to date.
            </p>
          </div>
        </div>
      </div>
    </div>
    

  </div>
</section>

</section>

<section>
  <div className="container my-lg-5 mt-20">
    <div className="row align-items-center justify-content-center textcenter">
      <div className="col-lg-5">
        <p className="fs-70 fw-800 plus font-25" style={{color:'rgba(0, 83, 154, 1)'}}>How it Works </p>

      </div>
      <div className="col-lg-7 text-center">
        <div className="pt-10 ">
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/How-it-works.png" alt="" className="img-fluid " />
        </div>
        <div className="textcenter mt-4 mt-40">
                <a href="#formsection">
                    <button type="button" className="btn btn-sm font-14  pt-2  px-4" style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(0, 83, 154, 1)',borderRadius:'45px',border:'none',outline:'none',paddingBottom:'10px',color:'rgba(255, 255, 255, 1)'}}>
                    Get a Free Quote Now  
                    </button>
                </a>
            </div>

      </div>
    </div>

  </div>
</section>



<section>
  <div className="container my-5">
    <p className="fs-35 fw-800 plus text-center font-25" style={{color:'rgba(26, 26, 26, 1)'}}>Industry - Leading Technologies We Utilized</p>
<div className="row justify-content-center">
  <div className="col-lg-8">
    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/TechStack-img.png" alt="" className="img-fluid mt-4" />

  </div>
</div>
  </div>
</section>


         
    

     


        <section className=" mt-lg-5 mt-30" >
    <div className="container pb-lg-5 ">
        <p className="fw-800 fs-35 plus text-center mb-0 font-23" style={{color:'#1B3567'}}>India's One Of The Highest Rated Website Development Company</p>
        <p className="fw-500 fs-20 plus text-center pt-2 font-18" style={{color:'#1B3567'}}> 100+ Glowing 5-Star Reviews Across Top B2B Review Platforms</p>

        <div className="row justify-content-center mt-4 g-2 p-10" >

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/clutch_img1.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid  "  />
                    {/* <img src={ratingstar} alt="" className="pt-2  "  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.8</p>
                                  

                </div>
            </div>
            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img2.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid  "  />
                    {/* <img src={ratingstar} alt="" className="pt-2  "   /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.9</p>
                                  

                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img3.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid heightwidth2" />
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.6</p>
                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img4.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid heightwidth2" />
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.4</p>
                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100 " style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo4.png" alt="box-img" style={{height:'100px',width:'75%',objectFit:'contain'}} className="img-fluid  " />

                    {/* <img src={ratingstar} alt="" className="pt-2"   /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-lg-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.8</p>
                </div>
            </div>
            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    
                    <div>
                        <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mob-add-img.png" alt="box-img" style={{height:'100px',width:'75%',objectFit:'contain'}} className="img-fluid" />

                        </div>
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-lg-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.4</p>
                </div>
            </div>

          
        </div>

    </div>

</section>





    <section>
                <div className="container  mt-20">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12 col-md-6">
                        <div className="text-center">
                                  <p className="fw-800 fs-33 plus font-23 " style={{color:'#1B3567'}}>What We Believe in</p>
                                {/* <p className="fw-500 fs-16 plus px-lg-5 " style={{color:'#000000',lineHeight:'30px'}}>We Committed To Delivering High-Quality Projects With a Strong Focus On On-Time Delivery. Our Team Prioritizes Efficient Workflows, Clear Communication, And Tailored Solutions To Ensure Every Project Is Completed Within The Agreed Timeline, Meeting And Exceeding Client Expectations</p> */}
                                <p className="fw-500 fs-16 plus " style={{color:'rgba(0, 0, 0, 0.6)',lineHeight:'25px'}}>We are committed to delivering high-quality projects with a strong focus on on-time delivery. Our team prioritizes efficient workflows, clear communication, and tailored solutions to ensure every project is completed within the agreed timeline, meeting and exceeding client expectations.</p>

                        </div>
                        </div>
                    </div>
                </div>
    </section>

            <section>
                <div className="container mt-4">
                    <div className="row g-2">
                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon2.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Security</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Our aim is to bring a new approach to secure your software based on integrity, trust and transparency</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon3.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Support</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>The best gift is time, and our 24/7 dedicated support team is always available to address your queries and concerns.</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon4.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Integrity</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Our expert team offers the best advice tailored to your product. We ensure guidance that drives success.</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon5.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Transparency</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Transparency means embracing new ideas, technology, and approaches. We firmly believe in fostering learning and openness.</p>

                        </div>
                        </div>
                    </div>
                </div>
            </section>



  <div id="formsection">

</div>

      
<section  className=" d-none d-sm-none d-md-block d-lg-block" style={{marginTop:'7%'}}>
   <NewForm/>

</section>

{/* Mobile View  */}
<section className="mt-lg-4 d-block d-sm-block d-md-none d-lg-none">
    <div className=" pt-3 pb-5 px-2 mt-30" style={{backgroundColor:'rgba(242, 242, 242, 1)'}}>
        <div className="container">
         
                      <p className="fw-600 text-center fs-23 plus mb-0 pt-1" >What can we help you with?</p>
                      <p className="fw-500 text-center fs-17 plus pt-3" style={{lineHeight:'22px'}}>Get Custom Solutions, Recommendations, or, Estimates.
                      Confidentiality & Same Day Response Guaranteed!</p>
    <div className="pt-1">
       <Form/>
    </div>

    <div className="d-flex justify-content-center gap-2 mt-4 ">

<div className="d-flex  gap-2">
    <div>
          <img src= "https://d3vqz9qyn2r1xe.cloudfront.net/imges/green-icon-form.svg" alt="" className="pt-1" />
    </div>
    <div>
           <p className="fw-600 plus fs-17  pt-1">100% Confidential</p>
    </div>
</div>

<div className="d-flex  gap-2">
    <div>
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/green-icon-form.svg" alt="" className="pt-1" />
    </div>
    <div>
           <p className="fw-600 plus fs-17  pt-1">We sign NDA</p>
    </div>
</div>

</div>

<div className="d-flex gap-4 mt-4">
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon1.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon2.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon3.svg" alt="" className="img-fluid pt-1" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon4.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon5.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon6.svg" alt="" className="img-fluid pt-2" />
            </div>
    </div>

      </div>
      </div>
</section>



{/* <section className="mt-5">
    <GoogleReviewsWidget/>
</section> */}

<section className="my-lg-5">
  <div className="container-fluid">
    <GoogleReviewsWidget2/>
    </div>
</section>






        <section style={{backgroundColor:'rgba(208, 233, 255, 1)'}}>
      <div className=" pt-5 pb-4">
          <Faqaccordian faqAccordianData={faqDataweb}/>
          </div>
      </section>



        <section >
                <Footer/>
        </section>

    </div>
);
};
export default WebsiteDevlopmentPageIndia;